import React from "react";
import Section from "./Section";
import { useStaticQuery, graphql } from "gatsby";

import PostLink from "./post-link";

const News = () => {
  const data = useStaticQuery(graphql`
    query {
      allMarkdownRemark(sort: { order: DESC, fields: [frontmatter___date] }) {
        edges {
          node {
            id
            excerpt(pruneLength: 250)
            frontmatter {
              date(formatString: "MMMM DD, YYYY")
              slug
              title
              excerpt
              featuredImage {
                childImageSharp {
                  fluid(maxWidth: 800) {
                    ...GatsbyImageSharpFluid
                  }
                }
              }
            }
          }
        }
      }
    }
  `);

  const Posts = data.allMarkdownRemark.edges
    .filter((edge) => !!edge.node.frontmatter.date)
    .map((edge) => <PostLink key={edge.node.id} post={edge.node} />);

  return (
    <Section
      bgColor="bg-slate-100"
      textColor="text-gold"
      comment="check it out!"
    >
      <h2 id="news" className="text-gold font-otomanopee mb-20">
        おしらせ
      </h2>
      {Posts}
    </Section>
  );
};

export default News;
